import { toPng } from 'html-to-image';
import StringUtils from './string-utils';

export const atMobileBreakpoint = () => window.matchMedia('(max-width: 767px)').matches;
const PASSWORD_FIELD_TYPE = 'password';

export const downloadDataAsCSV = function (csvData, fileName) {
  if (navigator.msSaveBlob) {
    const blob = new Blob([csvData], {
      type: 'text/csv;charset=utf8;',
    });
    navigator.msSaveBlob(blob, fileName);
  } else {
    const updatedCSV = encodeURIComponent(csvData);
    const data = encodeURI('data:text/csv;charset=utf-8,') + updatedCSV;
    const link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', fileName);
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
  }
};

/**
 * Given a list of columns (which may define CSV Formatting functions to format the
 * data in their respective columns) and list of rows, returns the data in a large string in CSV format
 * @param {*} columnObjects
 * @param {*} rows
 */
export const generateCSVData = (columnObjects, rows) => {
  let csvDataArray = [];
  const columnsToExport = columnObjects.filter((c) => c.fieldType != PASSWORD_FIELD_TYPE);
  const columnDisplayNames = columnsToExport.map((c) => c.label);
  csvDataArray.push(columnDisplayNames);

  csvDataArray = csvDataArray.concat(
    rows.map((row) => {
      const rowForCSV = columnsToExport.map((columnObject) => {
        let rowValue = row[columnObject.dataKey];

        if (columnObject.csvCellRenderer) {
          if (columnObject.useRowForCsvCellRenderer) {
            rowValue = columnObject.csvCellRenderer(row);
          } else {
            rowValue = columnObject.csvCellRenderer(rowValue);
          }
        }
        return StringUtils.encodeStringForCSV(rowValue);
      });

      return rowForCSV;
    }),
  );

  return csvDataArray.map((row) => row.join(',')).join('\n');
};

export const downloadElementAsImage = (element, fileName, options, callbackFn) => {
  if (atMobileBreakpoint) {
    forceDesktopView();
  }

  toPng(element, options).then((dataUrl) => {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.target = '_blank';
    link.download = fileName;
    link.click();
    callbackFn?.();

    if (atMobileBreakpoint) {
      forceDefaultViewport();
    }
  });
};

export const imgSrcToDataURL = (src, callback) => {
  const img = new Image();
  img.src = src;
  img.onload = function () {
    // https://stackoverflow.com/questions/49503171/the-image-tag-with-crossorigin-anonymous-cant-load-success-from-s3
    img.crossOrigin = 'anonymous';
    const canvas = document.createElement('CANVAS');
    const ctx = canvas.getContext('2d');
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    ctx.drawImage(this, 0, 0);
    const dataUrl = canvas.toDataURL('image/png');
    callback(dataUrl);
  };
};

const updateViewport = (content) => {
  document.getElementsByTagName('meta').viewport.content = content;
};

const forceDesktopView = () => {
  updateViewport(APP_CONSTANTS.FORCE_DESKTOP_VIEWPORT_META);
};

const forceDefaultViewport = () => {
  updateViewport(APP_CONSTANTS.DEFAULT_VIEWPORT_META);
};

export const beforeUnloadHandler = (e, shouldConfirm, msg) => {
  if (!shouldConfirm) {
    delete e.returnValue;
    return;
  }

  e.preventDefault();
  e.returnValue = msg;
};
